// extracted by mini-css-extract-plugin
export default {"icon-affirm-logo":"M8As5VaVKKZmtVc9d24BHg==","affirm-as-low-as":"+jx9kI4n05HxIDxxhre-ng==","affirm-line--hidden":"iBW0J6mvUMA09mZH1+6SPw=="};